import { Button, Form, Modal } from "react-bootstrap";
import "./modalcss.scss";
import OTPInput from "react-otp-input";
import React, { useEffect, useState } from "react";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import HelperService from "../../Services/HelperService";
interface PropsData {
    contactInfo: any;
    show: boolean;
    handleHide: (flag: boolean) => void;
}
const VerifyMobileOTP = ({
    contactInfo,
    show,
    handleHide,
}: PropsData) => {
    const [otp, setOtp] = useState<string>("");
    const [resendDisabled, setResendDisabled] = useState<boolean>(false);


    const handleResend = () => {
        WebService.addLoader("resend1");
        return WebService.postAPI({
            action: "verify-mobile/send-otp",
            body: {
                mobile_number: HelperService.removeDialCode(
                    contactInfo?.mobile_number,
                    contactInfo?.dial_code
                ),
                dial_code: contactInfo?.dial_code,
                country_code: contactInfo?.country_code,
            },
            isShowError: false,
        })
            .then((res: any) => {
                if (res?.status) {
                    toast.success(res.message);
                } else {
                    toast.error(res.message);
                }
            })
            .catch((error: any) => {
                toast.error(error?.response?.data?.message);
                WebService.removeLoader("verify-otp-btn");
                return error;
            })
            .finally(() => {
                WebService.removeLoader("resend1");
            });

        // SubmitOTPForm(getOTPData, "otp/resend");
    };
    const handleOTPVerify = () => {
        WebService.addLoader("verify-otp-btn");
        setResendDisabled(true);
        return WebService.postAPI({
            action: "verify-otp",
            body: {
                login_field: "MOBILE_NUMBER",
                otp: otp,
                mobile_number: HelperService.removeDialCode(
                    contactInfo?.mobile_number,
                    contactInfo?.dial_code
                ),
                dial_code: contactInfo?.dial_code,
                country_code: contactInfo?.country_code,
            },
            isShowError: false,
        })
            .then((res: any) => {
                if (res?.status) {
                    toast.success(res.message);
                    handleHide(true)
                } else {
                    toast.error(res.message);
                }
            })
            .catch((error: any) => {
                toast.error(error?.response?.data?.message);
                WebService.removeLoader("verify-otp-btn");
                return error;
            })
            .finally(() => {
                WebService.removeLoader("verify-otp-btn");
                setResendDisabled(false);

            });
    };
    return (
        <Modal
            show={show}
            onHide={() => handleHide(false)}
            //   className="right"
            keyboard={false}
            backdrop="static"
            centered
        >
            <Modal.Header closeButton className="border-bottom-0 pb-0 pt-1">
                {/* <Modal.Title>OTP Verification</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="pt-1">
                <React.Fragment>
                    <Form>
                        <h5>Verify Mobile Number</h5>
                        <div className="login-form">
                            <Form.Label className="label-text">
                                An OTP has been sent to {contactInfo?.dial_code}-
                                {contactInfo?.mobile_number &&
                                    HelperService.removeDialCode(
                                        contactInfo?.mobile_number,
                                        contactInfo?.dial_code
                                    )}{" "}
                                . The code is valid for 15 minutes.
                            </Form.Label>
                            <p className="para">Please enter OTP</p>
                            <div className="otp-input">
                                <OTPInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={6}
                                    renderSeparator={<span>-</span>}
                                    shouldAutoFocus={true}
                                    inputStyle={{
                                        width: "50px",
                                        height: "50px",
                                        margin: "0 10px",
                                        fontSize: "20px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        textAlign: "center",
                                    }}
                                    containerStyle={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                    renderInput={(props: any) => <input {...props} />}
                                />
                            </div>
                            <br />
                            <div className="d-flex justify-content-end">
                                <button
                                    id="resend1"
                                    onClick={() => handleResend()}
                                    disabled={resendDisabled}
                                    className="bg-white border-0 text-primary"
                                >
                                    Resend OTP
                                </button>
                            </div>
                            <div className="col-12 d-flex justify-content-center">
                                <Button
                                    disabled={otp.length < 6}
                                    variant="primary"
                                    id="verify-otp-btn"
                                    className="btn btn-primary cursor-pointer mb-2"
                                    style={{ width: "auto" }}
                                    onClick={() => handleOTPVerify()}
                                >
                                    Verify OTP
                                </Button>
                            </div>
                        </div>
                    </Form>
                    <hr></hr>
                </React.Fragment>

            </Modal.Body>
            <div className="row">
                {/* <div className="col-6">
          <Button
            disabled={otp.trim() === ""}
            variant="primary"
            id="clear-btn"
            className="btn btn-primary w-100 cursor-pointer"
            onClick={clearOtp}
          >
            Clear OTP
          </Button>
        </div> */}
            </div>
        </Modal >
    );
};
export default VerifyMobileOTP;
